module.exports = __webpack_public_path__ + "img/logo_suantanlab.8dc62a81.png";